import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=2659b204&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2659b204')) {
      api.createRecord('2659b204', component.options)
    } else {
      api.reload('2659b204', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=2659b204&", function () {
      api.rerender('2659b204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/avatar.vue"
export default component.exports